import { SET_HOME_SCREEN_NEARBY_UCS_PAGINATION } from "../types"

export const setHomeScreenNearbyUCSPagination = (pagination: any) => {
    return {
        type: SET_HOME_SCREEN_NEARBY_UCS_PAGINATION,
        payload: {
            pagination,
        }
    }
}